module.exports = __webpack_public_path__ + "img/10.a413b96c.jpg";